<template>
  <header>
    <b-navbar toggleable="md" type="dark" variant="info" style="box-shadow: 0px 2px #CCC;">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand href="#"><b>{{ brandTitle }}</b></b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item to="/" exact>
            <i class="fas fa-home"></i>
            Inicio
          </b-nav-item>
          <!-- <b-nav-item to="/mantenimiento" disabled>Mantenimiento</b-nav-item> -->
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          
          <b-nav-item-dropdown :text="menu.label" right v-for="(menu, i) in menus" :key="i">
            <template slot="button-content">
              <i :class="menu.icon"> </i> 
              <em>{{menu.label}} </em>
            </template>

            <div v-for="(children, i) in menu.childrens" :key="i">
              <b-dropdown-item v-if="children.type==0" :to="children.to">
                <i :class="children.icon"> </i> 
                {{children.label}}
              </b-dropdown-item>

              <div v-if="children.type==1" class="dropdown-divider"></div>

              <b-dropdown-item v-if="children.type==2" @click="children.click">
                <i :class="children.icon"></i>
                {{children.label}}
              </b-dropdown-item>
            </div>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown :text="getUser" right>
            <!-- Using button-content slot -->
            <template slot="button-content">
              <i class="far fa-user-circle"> </i>
               <em>  {{ getNombre }}  </em>
            </template>
            <b-dropdown-item to="/">
              <i class="far fa-user"></i> Mi Perfil
            </b-dropdown-item>
            <div class="dropdown-divider"></div>
            <b-dropdown-item @click="logout">
              <i class="fas fa-sign-out-alt"></i> Salir
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      brandTitle: "e-Coopex",
      menus: [
        {
          label: " Cuentas",
          icon: "fas fa-angle-right",
          childrens: [
            {
              type: 0,
              label: " Mis Cuentas",
              to: "miscuentas",
              //icon: "far fa-map",
              icon: "fas fa-list",
              click: null
            },
            {
              type: 0,
              label: " Mis Tarjetas",
              to: "mistarjetas",
              //icon: "far fa-map",
              icon: "fas fa-credit-card",
              click: null
            }
          ]
        },
        {
          label: " Transacciones",
          icon: "fas fa-angle-right",
          childrens: [
            {
              type: 0,
              label: " Transferencias",
              to: "transferencias",
              icon: "fas fa-exchange-alt",
              click: null
            },
            {
              type: 0,
              label: " Pagar Servicios",
              to: "pagarservicios",
              icon: "fas fa-receipt",
              click: null
            },
            {
              type: 0,
              label: " Pagar Tarjetas",
              to: "facilitador-list",
              icon: "fas fa-credit-card",
              click: null
            },
            {
              type: 0,
              label: " Sipap",
              to: "sipap",
              icon: "fas fa-exchange-alt",
              click: null
            },
            {
              type: 0,
              label: " InterCoop",
              to: "inter",
              icon: "fas fa-exchange-alt",
              click: null
            },
            
          ]
        }
      ]
    };
  },
  methods: {
    logout() {
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("usuarioId");
      window.localStorage.removeItem("usuario");
      window.localStorage.removeItem("nro_socio");
      window.localStorage.removeItem("nombre");
      window.localStorage.removeItem("apellido");
      window.localStorage.removeItem("ultimo_acceso");
      this.$router.push({ name: "Login" });
    }
  },
  computed: {
    getUser() {
      return window.localStorage.getItem("usuario") || "";
    },
    getNombre() {
      const nombre = window.localStorage.getItem("nombre").split(' ')
      return nombre[0]
    }
  }
};
</script>

<style scoped>
em {
  font-weight: bold;
}
.active {
  border-bottom: 1px solid whitesmoke;
}
.bg-info {
    background-color: #2153A0 !important;
}
</style>
